<script setup lang="ts">
import useLanguage from '@/composables/useLanguage'
import UITextButton from '../UITextButton.vue'

const i18n = useLanguage('UIModal')
</script>

<template>
  <UITextButton
    :text="i18n.cancel"
    type="button"
    weight="font-normal"
    variant="ghost"
    color="neutral"
    size="small"
  />
</template>
